(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.quosalImageUploadValidation = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {
    var ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
    var DANGEROUS_EXTENSIONS = [
        'php', 'asp', 'aspx', 'ashx', 'asmx', 'cer', 'cgi', 'exe', 'dll', 'bat', 'cmd',
        'com', 'msi', 'ps1', 'vbs', 'js', 'jsp', 'war', 'htaccess', 'config', 'cshtml', 'vbhtml'
    ];
    var UNSUPPORTED_MESSAGE = 'Please upload a supported image file (.jpg, .jpeg, .png, .gif, or .bmp).';

    function getBaseFileName(filename) {
        if (!filename) {
            return '';
        }

        return filename.substring(filename.lastIndexOf('\\') + 1);
    }

    function getTrailingExtension(filename) {
        var baseName = getBaseFileName(filename);
        var lastDot = baseName.lastIndexOf('.');
        if (lastDot < 0) {
            return '';
        }

        return baseName.substring(lastDot).toLowerCase();
    }

    function hasDangerousInnerExtension(filename) {
        var baseName = getBaseFileName(filename);
        var lastDot = baseName.lastIndexOf('.');
        if (lastDot <= 0) {
            return false;
        }

        var namePart = baseName.substring(0, lastDot);
        if (namePart.indexOf('.') < 0) {
            return false;
        }

        var segments = namePart.split('.');
        for (var i = 0; i < segments.length; i++) {
            var segment = segments[i].replace(/[/\\]+$/, '').toLowerCase();
            if (DANGEROUS_EXTENSIONS.indexOf(segment) >= 0) {
                return true;
            }
        }

        return false;
    }

    function hasAllowedImageExtension(filename) {
        return ALLOWED_EXTENSIONS.indexOf(getTrailingExtension(filename)) >= 0;
    }

    function getValidationError(filename) {
        if (!filename) {
            return UNSUPPORTED_MESSAGE;
        }

        if (getBaseFileName(filename).indexOf('/') >= 0) {
            return UNSUPPORTED_MESSAGE;
        }

        if (!hasAllowedImageExtension(filename) || hasDangerousInnerExtension(filename)) {
            return UNSUPPORTED_MESSAGE;
        }

        return null;
    }

    return {
        getValidationError: getValidationError,
        unsupportedMessage: UNSUPPORTED_MESSAGE
    };
}));
